module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-4.jpg?f77897c8";